import { appListLimits } from '@common/constants'
import { useAppSelector } from '@common/hooks'
import cx from 'classnames'
import get from 'lodash/get'
import { useRouter } from 'next/router'
import { useCallback } from 'react'
import ReactPaginate from 'react-paginate'

import classNames from './styles.module.scss'


interface IProps {
  reducer: AppListReducer,
}

export default function Pagination({ reducer }: IProps): JSX.Element | null {
  const router = useRouter()

  const totalCount = useAppSelector((state) => get(state[reducer], 'data.total', 0))
  const limit = useAppSelector((state) => state[reducer].filters.limit || appListLimits)
  const offset = useAppSelector((state) => state[reducer].filters.offset || 0)

  const currentPage = Math.floor(offset / limit)
  const totalPages = Math.ceil(totalCount / limit)

  const handlePageClick = useCallback(({ selected }: { selected: number }) => {
    if(selected !== currentPage && process.browser) {
      const offset = selected * limit
      const query = {
        ...router.query,
      }
      if(offset <= 0) {
        delete query.page
      } else {
        query.page = String(selected + 1)
      }
      void router.push({
        pathname: router.asPath.split('?')[0],
        query,
      }, undefined, { shallow: true })

      document.querySelector('#__next')?.scrollTo(0, 0)
    }
  }, [limit, router.query, currentPage])

  if(totalPages === 1) { return null }

  return (
    <ReactPaginate
      previousLabel={
        <button className={classNames.control} tabIndex={-1} data-test="previous-page-btn">
          <span className={cx(classNames.arrow, classNames.rotate)}/>
        </button>
      }
      forcePage={currentPage}
      previousClassName={classNames.previous}
      nextClassName={classNames.next}
      nextLabel={
        <button className={classNames.control} tabIndex={-1} data-test="next-page-btn">
          <span className={classNames.arrow}/>
        </button>
      }
      breakLabel="..."
      pageClassName={classNames.page}
      breakClassName={classNames.break}
      pageCount={totalPages}
      marginPagesDisplayed={1}
      pageRangeDisplayed={5}
      onPageChange={handlePageClick}
      containerClassName={classNames.pagination}
      disabledClassName={classNames.disabled}
      activeClassName={classNames.active}
    />
  )
}
